import { getUtmDataForSalesFloorApp } from 'shared/utils/getUtmDataForSalesFloorApp';
import { sendTrackingEvent } from 'tracking/utils/sendTrackingEvent';

export const sendTrackingPdpView = ({ prevPath, id, name, slug, brandName, query, sku }) => {
  sendTrackingEvent('PDP_VIEW', {
    product_template_id: id,
    product_template_name: name,
    product_template_slug: slug,
    content_type: 'product_group',
    reference_source: prevPath,
    brand_name: brandName,
    sku,
  });

  const utmDataForSalesFloorApp = getUtmDataForSalesFloorApp(query);
  if (utmDataForSalesFloorApp) {
    sendTrackingEvent('SALESFLOOR_PDP_VIEW', utmDataForSalesFloorApp);
  }
};
